
// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import { fetchCampaigns } from "../services/campaignService";
// import { fetchJobList } from "../services/jobListService";
// import "./CommandCenter.css";

// const API_BASE_URL =
//   process.env.REACT_APP_API_URL || "http://localhost:8000";

// function CommandCenter() {
//   const [dashboardData, setDashboardData] = useState(null);
//   const [completedJobsTotal, setCompletedJobsTotal] = useState(0);
//   const [discrepancyFoundCount, setDiscrepancyFoundCount] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   useEffect(() => {
//     const fetchDashboardData = async () => {
//       try {
//         setLoading(true);
//         setError("");

//         const storedUser = localStorage.getItem("user");
//         const parsedUser = storedUser ? JSON.parse(storedUser) : null;

//         if (!parsedUser?.id) {
//           throw new Error("User session not found");
//         }

//         const userId = parsedUser.id;

//         // Fetch dashboard summary
//         const response = await fetch(
//           `${API_BASE_URL}/api/dashboard/summary`,
//           {
//             headers: {
//               "X-User-Id": String(userId),
//             },
//           }
//         );

//         if (!response.ok) {
//           throw new Error(
//             `Dashboard API failed with status ${response.status}`
//           );
//         }

//         const data = await response.json();
//         setDashboardData(data);

//         // Fetch campaigns to calculate completedJobsTotal dynamically
//         const campaignData = await fetchCampaigns();
//         const campaigns = Array.isArray(campaignData)
//           ? campaignData
//           : campaignData?.data || [];

//         const totalCompleted = campaigns.reduce(
//           (total, campaign) =>
//             total + Number(campaign.completed_job_count || 0),
//           0
//         );

//         setCompletedJobsTotal(totalCompleted);

//         // Fetch all discrepancy jobs and calculate unique job count
//         try {
//           let allDiscrepancyJobs = [];
//           let page = 1;
//           let totalPages = 1;

//           do {
//             const response = await fetchJobList({
//               page,
//               pageSize: 100,
//               campaignId: "",
//               brandId: "",
//               status: "",
//               discrepancy: "yes",
//               search: "",
//             });

//             const data = response?.data || {};

//             allDiscrepancyJobs = [
//               ...allDiscrepancyJobs,
//               ...(data.items || []),
//             ];

//             totalPages = Number(data.total_pages || 1);
//             page += 1;
//           } while (page <= totalPages);

//           const uniqueDiscrepancyJobIds = new Set(
//             allDiscrepancyJobs
//               .map((job) => job?.job_id)
//               .filter((jobId) => jobId !== null && jobId !== undefined)
//           );

//           setDiscrepancyFoundCount(uniqueDiscrepancyJobIds.size);
//         } catch (err) {
//           console.error(
//             "[COMMAND CENTER] Discrepancy count error:",
//             err
//           );
//           setDiscrepancyFoundCount(0);
//         }
//       } catch (err) {
//         console.error("Dashboard API Error:", err);
//         setError("Unable to load dashboard data.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchDashboardData();
//   }, []);

//   if (loading) {
//     return (
//       <div className="command-center-wrapper">
//         <div className="cc-card">
//           <div className="kpi-label">Loading dashboard...</div>
//         </div>
//       </div>
//     );
//   }

//   if (error) {
//     return (
//       <div className="command-center-wrapper">
//         <div className="cc-card">
//           <div className="kpi-label">{error}</div>
//         </div>
//       </div>
//     );
//   }

//   if (!dashboardData) {
//     return null;
//   }

//   const kpis = dashboardData.kpis || {};
//   const brandPerformance = dashboardData.brand_performance || [];
//   const vendorPerformance = dashboardData.vendor_performance || [];
//   const recentActivity = dashboardData.recent_activity || [];
//   const aiInsights = dashboardData.ai_insights || [];
//   const attentionItems = dashboardData.attention_items || [];

//   return (
//     <div className="command-center-wrapper">
//       <div className="cc-welcome-card">
//         <div className="welcome-text">
//           <h2>Good Morning, Operations Team 👋</h2>
//           <p>
//             Here is your real-time execution overview across active field campaigns.
//           </p>
//         </div>
//         <div className="welcome-actions">
//           <Link to="/create-campaign" className="btn-cc-primary">
//             + New Campaign
//           </Link>
//         </div>
//       </div>

//       <div className="cc-summary-banner">
//         <span className="summary-badge">Executive Summary</span>
//         <span className="summary-text">
//           Active Campaigns:{" "}
//           <strong>
//             {Number(kpis.active_campaigns || 0).toLocaleString()}
//           </strong>
//           {" • "}
//           Jobs Running:{" "}
//           <strong>
//             {Number(kpis.jobs_running || 0).toLocaleString()}
//           </strong>
//           {" • "}
//           Today's Completed Jobs:{" "}
//           <strong>
//             {Number(kpis.today_completed_jobs || 0).toLocaleString()}
//           </strong>
//         </span>
//       </div>

//       <div className="cc-kpi-grid">
//         {/* 1. Active Campaigns */}
//         <a
//           href="/campaign-list"
//           target="_blank"
//           rel="noopener noreferrer"
//           className="cc-kpi-card"
//         >
//           <div className="kpi-icon icon-blue">📢</div>
//           <div className="kpi-content">
//             <div className="kpi-value">
//               {Number(kpis.active_campaigns || 0).toLocaleString()}
//             </div>
//             <div className="kpi-label">Active Campaigns</div>
//           </div>
//         </a>

//         {/* 2. Jobs Running */}
//         <a
//           href="/job-list"
//           target="_blank"
//           rel="noopener noreferrer"
//           className="cc-kpi-card"
//         >
//           <div className="kpi-icon icon-green">📍</div>
//           <div className="kpi-content">
//             <div className="kpi-value">
//               {Number(kpis.jobs_running || 0).toLocaleString()}
//             </div>
//             <div className="kpi-label">Jobs Running</div>
//           </div>
//         </a>

//         {/* 3. Completed Jobs */}
//         <a
//           href="/job-list?status=completed"
//           target="_blank"
//           rel="noopener noreferrer"
//           className="cc-kpi-card"
//         >
//           <div className="kpi-icon icon-orange">📷</div>
//           <div className="kpi-content">
//             <div className="kpi-value">
//               {Number(completedJobsTotal).toLocaleString()}
//             </div>
//             <div className="kpi-label">Completed Jobs</div>
//           </div>
//         </a>

//         {/* 4. Discrepancy Found */}
//         <a
//           href="/job-list?discrepancy=yes"
//           target="_blank"
//           rel="noopener noreferrer"
//           className="cc-kpi-card"
//         >
//           <div className="kpi-icon icon-red">⚠️</div>
//           <div className="kpi-content">
//             <div className="kpi-value">
//               {Number(discrepancyFoundCount).toLocaleString()}
//             </div>
//             <div className="kpi-label">Discrepancy Found</div>
//           </div>
//         </a>
//       </div>

//       <div className="cc-brand-section">
//         <div className="section-header-text">
//           <h3>Brand Performance</h3>
//           <span className="subtext">Live execution status</span>
//         </div>

//         <div className="cc-brand-grid">
//           {brandPerformance.length > 0 ? (
//             brandPerformance.map((brand) => (
//               <div className="brand-card" key={brand.brand_id}>
//                 <div className="brand-card-top">
//                   <span className="brand-name">{brand.brand_name}</span>
//                   {brand.performance !== undefined && (
//                     <span
//                       className={`badge-percent ${
//                         brand.performance >= 90
//                           ? "success"
//                           : brand.performance >= 70
//                           ? "warning"
//                           : "danger"
//                       }`}
//                     >
//                       {brand.performance}%
//                     </span>
//                   )}
//                 </div>

//                 <div className="brand-card-body">
//                   <span className="brand-meta-label">Jobs</span>
//                   <span className="brand-meta-value">
//                     {Number(brand.jobs || 0).toLocaleString()}{" "}
//                     ({Number(brand.completed_jobs || 0).toLocaleString()})
//                   </span>
//                 </div>

//                 {brand.performance !== undefined && (
//                   <div className="brand-progress-bar">
//                     <div
//                       className={`brand-progress-fill ${
//                         brand.performance >= 90
//                           ? "green"
//                           : brand.performance >= 70
//                           ? "yellow"
//                           : "blue"
//                       }`}
//                       style={{ width: `${brand.performance}%` }}
//                     />
//                   </div>
//                 )}
//               </div>
//             ))
//           ) : (
//             <div className="cc-card">
//               <span className="subtext">
//                 No brand performance data available.
//               </span>
//             </div>
//           )}
//         </div>
//       </div>

//       <div className="cc-split-grid">
//         <div className="cc-card">
//           <div className="card-header-flex">
//             <div>
//               <h3>Vendor Leaderboard</h3>
//               <span className="subtext">Top performing vendors this month</span>
//             </div>
//           </div>

//           {vendorPerformance.length > 0 ? (
//             <div className="table-responsive">
//               <table className="cc-table">
//                 <thead>
//                   <tr>
//                     <th>VENDOR</th>
//                     <th>CAMPAIGNS</th>
//                     <th>COMPLETION</th>
//                     <th>RATING</th>
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {vendorPerformance.map((vendor) => (
//                     <tr key={vendor.vendor_id || vendor.id}>
//                       <td>
//                         <strong>{vendor.vendor_name || vendor.name}</strong>
//                       </td>
//                       <td>{vendor.campaigns}</td>
//                       <td>
//                         <span className="badge-percent success">
//                           {vendor.completion}%
//                         </span>
//                       </td>
//                       <td>
//                         <span className="rating-stars">
//                           {vendor.rating || "★★★★★"}
//                         </span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>
//           ) : (
//             <div className="subtext">No vendor performance data available.</div>
//           )}
//         </div>

//         <div className="cc-card">
//           <div className="card-header-flex">
//             <div>
//               <h3>Recent Activity</h3>
//             </div>
//           </div>

//           {recentActivity.length > 0 ? (
//             <div className="timeline-list">
//               {recentActivity.map((activity, index) => (
//                 <div className="timeline-item" key={activity.id || index}>
//                   <div className="timeline-dot"></div>
//                   <div className="timeline-content">
//                     <span className="timeline-time">{activity.time}</span>
//                     <strong>{activity.title}</strong>
//                     <p>{activity.description}</p>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="subtext">No recent activity recorded.</div>
//           )}
//         </div>
//       </div>

//       <div className="cc-split-grid">
//         <div className="cc-card">
//           <div className="card-header-flex">
//             <div>
//               <h3>AI Insights</h3>
//             </div>
//           </div>

//           {aiInsights.length > 0 ? (
//             <div className="insights-stack">
//               {aiInsights.map((insight, index) => (
//                 <div
//                   className={`insight-box ${insight.type || "info"}`}
//                   key={insight.id || index}
//                 >
//                   <span className="insight-icon">{insight.icon || "💡"}</span>
//                   <div>
//                     <strong>{insight.title}</strong>
//                     {insight.description && <p>{insight.description}</p>}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="subtext">No insights generated.</div>
//           )}
//         </div>

//         <div className="cc-card">
//           <div className="card-header-flex">
//             <div>
//               <h3>Attention Center</h3>
//             </div>
//           </div>

//           {attentionItems.length > 0 ? (
//             <div className="attention-stack">
//               {attentionItems.map((item, index) => (
//                 <div
//                   className={`attention-item ${item.type || "warning"}`}
//                   key={item.id || index}
//                 >
//                   <span className="attention-icon">{item.icon || "⚠️"}</span>
//                   <span>{item.message}</span>
//                 </div>
//               ))}
//             </div>
//           ) : (
//             <div className="subtext">No items require attention.</div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default CommandCenter;

import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { fetchCampaigns } from "../services/campaignService";
import { fetchJobList } from "../services/jobListService";
import "./CommandCenter.css";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8000";

function CommandCenter() {
  const [dashboardData, setDashboardData] = useState(null);
  const [completedJobsTotal, setCompletedJobsTotal] = useState(0);
  const [discrepancyFoundCount, setDiscrepancyFoundCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDashboardData = async () => {
      try {
        setLoading(true);
        setError("");

        const storedUser = localStorage.getItem("user");
        const parsedUser = storedUser ? JSON.parse(storedUser) : null;

        if (!parsedUser?.id) {
          throw new Error("User session not found");
        }

        const userId = parsedUser.id;

        // Fetch dashboard summary
        const response = await fetch(
          `${API_BASE_URL}/api/dashboard/summary`,
          {
            headers: {
              "X-User-Id": String(userId),
            },
          }
        );

        if (!response.ok) {
          throw new Error(
            `Dashboard API failed with status ${response.status}`
          );
        }

        const data = await response.json();
        setDashboardData(data);

        // Fetch campaigns to calculate completedJobsTotal dynamically
        const campaignData = await fetchCampaigns();
        const campaigns = Array.isArray(campaignData)
          ? campaignData
          : campaignData?.data || [];

        const totalCompleted = campaigns.reduce(
          (total, campaign) =>
            total + Number(campaign.completed_job_count || 0),
          0
        );

        setCompletedJobsTotal(totalCompleted);

        // Fetch all discrepancy jobs and calculate unique job count
        try {
          let allDiscrepancyJobs = [];
          let page = 1;
          let totalPages = 1;

          do {
            const response = await fetchJobList({
              page,
              pageSize: 100,
              campaignId: "",
              brandId: "",
              status: "",
              discrepancy: "yes",
              search: "",
            });

            const data = response?.data || {};

            allDiscrepancyJobs = [
              ...allDiscrepancyJobs,
              ...(data.items || []),
            ];

            totalPages = Number(data.total_pages || 1);
            page += 1;
          } while (page <= totalPages);

          const uniqueDiscrepancyJobIds = new Set(
            allDiscrepancyJobs
              .map((job) => job?.job_id)
              .filter((jobId) => jobId !== null && jobId !== undefined)
          );

          setDiscrepancyFoundCount(uniqueDiscrepancyJobIds.size);
        } catch (err) {
          console.error(
            "[COMMAND CENTER] Discrepancy count error:",
            err
          );
          setDiscrepancyFoundCount(0);
        }
      } catch (err) {
        console.error("Dashboard API Error:", err);
        setError("Unable to load dashboard data.");
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardData();
  }, []);

  if (loading) {
    return (
      <div className="command-center-wrapper">
        <div className="cc-card">
          <div className="kpi-label">Loading dashboard...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="command-center-wrapper">
        <div className="cc-card">
          <div className="kpi-label">{error}</div>
        </div>
      </div>
    );
  }

  if (!dashboardData) {
    return null;
  }

  const kpis = dashboardData.kpis || {};
  const brandPerformance = dashboardData.brand_performance || [];
  const vendorPerformance = dashboardData.vendor_performance || [];
  const recentActivity = dashboardData.recent_activity || [];
  const aiInsights = dashboardData.ai_insights || [];
  const attentionItems = dashboardData.attention_items || [];

  return (
    <div className="command-center-wrapper">
      <div className="cc-welcome-card">
        <div className="welcome-text">
          <h2>Good Morning, Operations Team 👋</h2>
          <p>
            Here is your real-time execution overview across active field campaigns.
          </p>
        </div>
        <div className="welcome-actions">
          <Link to="/create-campaign" className="btn-cc-primary">
            + New Campaign
          </Link>
        </div>
      </div>

      <div className="cc-summary-banner">
        <span className="summary-badge">Executive Summary</span>

        <span className="summary-text">
          <span
            className="summary-link"
            onClick={() =>
              window.open(
                "/campaign-list",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            Active Campaigns:{" "}
            <strong>
              {Number(kpis.active_campaigns || 0).toLocaleString()}
            </strong>
          </span>

          {" • "}

          <span
            className="summary-link"
            onClick={() =>
              window.open(
                "/job-list",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            Jobs Running:{" "}
            <strong>
              {Number(kpis.jobs_running || 0).toLocaleString()}
            </strong>
          </span>

          {" • "}

          <span
            className="summary-link"
            onClick={() =>
              window.open(
                "/job-list?status=today_completed",
                "_blank",
                "noopener,noreferrer"
              )
            }
          >
            Today's Completed Jobs:{" "}
            <strong>
              {Number(kpis.today_completed_jobs || 0).toLocaleString()}
            </strong>
          </span>
        </span>
      </div>

      <div className="cc-kpi-grid">
        {/* 1. Active Campaigns */}
        <a
          href="/campaign-list"
          target="_blank"
          rel="noopener noreferrer"
          className="cc-kpi-card"
        >
          <div className="kpi-icon icon-blue">📢</div>
          <div className="kpi-content">
            <div className="kpi-value">
              {Number(kpis.active_campaigns || 0).toLocaleString()}
            </div>
            <div className="kpi-label">Active Campaigns</div>
          </div>
        </a>

        {/* 2. Jobs Running */}
        <a
          href="/job-list"
          target="_blank"
          rel="noopener noreferrer"
          className="cc-kpi-card"
        >
          <div className="kpi-icon icon-green">📍</div>
          <div className="kpi-content">
            <div className="kpi-value">
              {Number(kpis.jobs_running || 0).toLocaleString()}
            </div>
            <div className="kpi-label">Jobs Running</div>
          </div>
        </a>

        {/* 3. Completed Jobs */}
        <a
          href="/job-list?status=completed"
          target="_blank"
          rel="noopener noreferrer"
          className="cc-kpi-card"
        >
          <div className="kpi-icon icon-orange">📷</div>
          <div className="kpi-content">
            <div className="kpi-value">
              {Number(completedJobsTotal).toLocaleString()}
            </div>
            <div className="kpi-label">Completed Jobs</div>
          </div>
        </a>

        {/* 4. Discrepancy Found */}
        <a
          href="/job-list?discrepancy=yes"
          target="_blank"
          rel="noopener noreferrer"
          className="cc-kpi-card"
        >
          <div className="kpi-icon icon-red">⚠️</div>
          <div className="kpi-content">
            <div className="kpi-value">
              {Number(discrepancyFoundCount).toLocaleString()}
            </div>
            <div className="kpi-label">Discrepancy Found</div>
          </div>
        </a>
      </div>

      <div className="cc-brand-section">
        <div className="section-header-text">
          <h3>Brand Performance</h3>
          <span className="subtext">Live execution status</span>
        </div>

        <div className="cc-brand-grid">
          {brandPerformance.length > 0 ? (
            brandPerformance.map((brand) => (
              <div className="brand-card" key={brand.brand_id}>
                <div className="brand-card-top">
                  <span className="brand-name">{brand.brand_name}</span>
                  {brand.performance !== undefined && (
                    <span
                      className={`badge-percent ${
                        brand.performance >= 90
                          ? "success"
                          : brand.performance >= 70
                          ? "warning"
                          : "danger"
                      }`}
                    >
                      {brand.performance}%
                    </span>
                  )}
                </div>

                <div className="brand-card-body">
                  <span className="brand-meta-label">Jobs</span>
                  <span className="brand-meta-value">
                    {Number(brand.jobs || 0).toLocaleString()}{" "}
                    ({Number(brand.completed_jobs || 0).toLocaleString()})
                  </span>
                </div>

                {brand.performance !== undefined && (
                  <div className="brand-progress-bar">
                    <div
                      className={`brand-progress-fill ${
                        brand.performance >= 90
                          ? "green"
                          : brand.performance >= 70
                          ? "yellow"
                          : "blue"
                      }`}
                      style={{ width: `${brand.performance}%` }}
                    />
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="cc-card">
              <span className="subtext">
                No brand performance data available.
              </span>
            </div>
          )}
        </div>
      </div>

      <div className="cc-split-grid">
        <div className="cc-card">
          <div className="card-header-flex">
            <div>
              <h3>Vendor Leaderboard</h3>
              <span className="subtext">Top performing vendors this month</span>
            </div>
          </div>

          {vendorPerformance.length > 0 ? (
            <div className="table-responsive">
              <table className="cc-table">
                <thead>
                  <tr>
                    <th>VENDOR</th>
                    <th>CAMPAIGNS</th>
                    <th>COMPLETION</th>
                    <th>RATING</th>
                  </tr>
                </thead>
                <tbody>
                  {vendorPerformance.map((vendor) => (
                    <tr key={vendor.vendor_id || vendor.id}>
                      <td>
                        <strong>{vendor.vendor_name || vendor.name}</strong>
                      </td>
                      <td>{vendor.campaigns}</td>
                      <td>
                        <span className="badge-percent success">
                          {vendor.completion}%
                        </span>
                      </td>
                      <td>
                        <span className="rating-stars">
                          {vendor.rating || "★★★★★"}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <div className="subtext">No vendor performance data available.</div>
          )}
        </div>

        <div className="cc-card">
          <div className="card-header-flex">
            <div>
              <h3>Recent Activity</h3>
            </div>
          </div>

          {recentActivity.length > 0 ? (
            <div className="timeline-list">
              {recentActivity.map((activity, index) => (
                <div className="timeline-item" key={activity.id || index}>
                  <div className="timeline-dot"></div>
                  <div className="timeline-content">
                    <span className="timeline-time">{activity.time}</span>
                    <strong>{activity.title}</strong>
                    <p>{activity.description}</p>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="subtext">No recent activity recorded.</div>
          )}
        </div>
      </div>

      <div className="cc-split-grid">
        <div className="cc-card">
          <div className="card-header-flex">
            <div>
              <h3>AI Insights</h3>
            </div>
          </div>

          {aiInsights.length > 0 ? (
            <div className="insights-stack">
              {aiInsights.map((insight, index) => (
                <div
                  className={`insight-box ${insight.type || "info"}`}
                  key={insight.id || index}
                >
                  <span className="insight-icon">{insight.icon || "💡"}</span>
                  <div>
                    <strong>{insight.title}</strong>
                    {insight.description && <p>{insight.description}</p>}
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <div className="subtext">No insights generated.</div>
          )}
        </div>

        <div className="cc-card">
          <div className="card-header-flex">
            <div>
              <h3>Attention Center</h3>
            </div>
          </div>

          {attentionItems.length > 0 ? (
            <div className="attention-stack">
              {attentionItems.map((item, index) => (
                <div
                  className={`attention-item ${item.type || "warning"}`}
                  key={item.id || index}
                >
                  <span className="attention-icon">{item.icon || "⚠️"}</span>
                  <span>{item.message}</span>
                </div>
              ))}
            </div>
          ) : (
            <div className="subtext">No items require attention.</div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CommandCenter;